import { useQuery } from '@apollo/client';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { USER_COMMENT_QUERY } from '../../../helpers/graphql/comments';
import { getUser } from '../../../helpers/token';
import CommentItem from '../../Post/Comments/CommentItem';
import FirstPostCard from '../FirstPostCard';

const CommentList = ({ tab, increaseUnreadCountOffset }) => {
  const user = getUser();

  const [hasMore, setHasMore] = useState(false);

  let variables = {};
  if (tab === 0) {
    variables = { parentAuthor: user, onlyUnread: true, excludeAuthor: user };
  } else if (tab === 1) {
    variables = { parentAuthor: user, excludeAuthor: user };
  } else if (tab === 2) {
    variables = { author: user };
  }

  const onCompleted = res => {
    if (res && res.userComments && res.userComments.length >= 10)
      setHasMore(true);
  };

  const { data, fetchMore } = useQuery(USER_COMMENT_QUERY, {
    variables: { limit: 10, offset: 0, ...variables },
    ssr: false,
    onCompleted,
  });

  const loader = (
    <div className="col-12 p-5 text-center" key="loader">
      <CircularProgress />
    </div>
  );

  return (
    <>
      <InfiniteScroll
        loadMore={() => {
          if (fetchMore)
            fetchMore({
              variables: {
                offset:
                  data && data.userComments ? data.userComments.length : 0,
              },
              updateQuery: (prev, { fetchMoreResult }) => {
                if (fetchMoreResult.userComments.length < 10) {
                  setHasMore(false);
                }
                if (!fetchMoreResult) return prev;
                return Object.assign({}, prev, {
                  userComments: [
                    ...prev.userComments,
                    ...fetchMoreResult.userComments,
                  ],
                });
              },
            });
        }}
        hasMore={hasMore}
        threshold={1000}
        loader={loader}
      >
        <div className="container-fluid pb-2">
          <div className="row justify-content-center">
            <div className="col-xl-8 col-lg-10 col-md-10 col-sm-11 col-12">
              {data && data.userComments ? (
                <>
                  {data.userComments.length === 0 ? (
                    <div className="container d-flex justify-content-center mt-5 mb-5">
                      <div style={{ maxWidth: '800px' }}>
                        <FirstPostCard title="Start writing and the replies will come!" />
                      </div>
                    </div>
                  ) : (
                    data.userComments.map(comment => {
                      return (
                        <CommentItem
                          key={`${comment.author.username}/${comment.permlink}`}
                          comment={comment}
                          ignoreDepth
                          showReadButton={tab !== 2}
                          withMarginTop
                          hideReplyBtn={tab === 2}
                          increaseUnreadCountOffset={increaseUnreadCountOffset}
                        />
                      );
                    })
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </InfiniteScroll>
    </>
  );
};

export default CommentList;
